import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { getTenantFromBrowser } from '@/utils/tenant.js';
import './platform.css';

const API = import.meta.env.VITE_API_URL || 'https://api.sinamonsoft.ar';

export default function TenantActivation() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(event) {
    event.preventDefault(); setError('');
    if (password !== confirmation) return setError('Las contraseñas no coinciden.');
    setBusy(true);
    try {
      const response = await fetch(`${API}/auth/activate`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Tenant': getTenantFromBrowser() }, body: JSON.stringify({ token: params.get('token'), password }) });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.message || 'No se pudo activar la cuenta.');
      setMessage(payload.message);
    } catch (cause) { setError(cause.message); } finally { setBusy(false); }
  }

  return <main className="pa-login"><section className="pa-login-card"><div className="pa-brand-mark"><ShieldCheck size={30}/></div><p className="pa-eyebrow">Sinamon</p><h1>Activar administrador</h1><p className="pa-muted">Defina su contraseña inicial. El enlace vence y sólo puede utilizarse una vez.</p>{message?<div className="pa-stack"><div className="pa-success">{message}</div><Link className="pa-primary pa-link" to="/login">Ir al login</Link></div>:<form className="pa-stack" onSubmit={submit}><label className="pa-field"><span>Nueva contraseña</span><input type="password" value={password} onChange={event=>setPassword(event.target.value)} minLength={12} required/></label><label className="pa-field"><span>Confirmar contraseña</span><input type="password" value={confirmation} onChange={event=>setConfirmation(event.target.value)} minLength={12} required/></label>{error&&<div className="pa-error">{error}</div>}<button className="pa-primary" disabled={busy}>{busy?'Activando…':'Activar cuenta'}</button></form>}</section></main>;
}
